import {reduxForm, Field, formValueSelector} from 'redux-form'
import SettingField from 'components/Fields/ReduxForm/SettingField'
import AssignOutletModal from './AssignOutletModal'
import {connect} from 'react-redux'
import {assignOutlets} from 'actions/employees/list'
import styles from './InviteForm.css'

const validate = (values) => {
  const errors = {}

  let message = 'This field is required'
  if (!values.firstName) {
    errors.firstName = message
  }

  if (!values.lastName) {
    errors.lastName = message
  }

  if (!values.email) {
    errors.email = 'This field is required'
  } else {
    if ((!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email))) {
      errors.email = 'The value is not a valid email address'
    }
  }

  return errors
}

class Wrapper extends React.Component {
  render () {
    return (<div className='col-lg-6 col-md-6 col-sm-6'>
      <div className={styles['form-group']}>{this.props.children}</div>
    </div>)
  }
}

class WrapperBlock extends React.Component {
  render () {
    return (<div className='col-sm-12'>
      <div className={styles['form-group']}>{this.props.children}</div>
    </div>)
  }
}

class InviteForm extends React.Component {
  render () {
    let {dispatch, handleSubmit, data: {employee: {list: {checkedOutlets, profile}}}} = this.props

    let selectedOutlets = 0
    // outlets undefined means the redux form is still loading
    checkedOutlets.forEach((co) => {
      if (co.checked) selectedOutlets++
    })

    return (<form onSubmit={handleSubmit}>
      <div className='row'>
        <Wrapper>
          <Field
            component={SettingField}
            name='firstName'
            placeholder='First Name'
          />
        </Wrapper>
        <Wrapper>
          <Field
            component={SettingField}
            name='lastName'
            placeholder='Last Name'
          />
        </Wrapper>
      </div>
      <div className='row'>
        <Wrapper>
          <Field
            component={SettingField}
            name='email'
            placeholder='Email'
          />
        </Wrapper>
        <Wrapper>
          <Field
            component={SettingField}
            name='title'
            placeholder='Title'
          />
        </Wrapper>
      </div>
      <div className='row'>
        <Wrapper>
          <button className='btn btn-primary btn-block' type='button' onClick={this._onClickAssignOutlet}>
            {!selectedOutlets && 'Assign Outlet'}{(selectedOutlets > 0) && `${selectedOutlets} outlets`}
          </button>
        </Wrapper>
        <Wrapper>
          {profile && profile.is_owner && <Field
            component='select'
            name='permission'
            className='form-control'>
            <option selected='true' value='-1'>Please Select Permissions</option>
            <option value='0'>App Only</option>
            <option value='1'>App and Backoffice</option>
          </Field>}
        </Wrapper>
      </div>
      <div className='row'>
        <WrapperBlock>
          <Field
            component='input'
            name='password'
            readOnly='true'
            className='form-control' />
        </WrapperBlock>
      </div>
      <div className='row'>
        <WrapperBlock>
          <button className='btn btn-primary btn-block'>Send Invitation</button>
        </WrapperBlock>
      </div>
      <AssignOutletModal dispatch={dispatch} />
    </form>)
  }

  _onClickAssignOutlet = () => {
    let {checkedOutlets} = this.props.data.employee.list
    this.props.dispatch(assignOutlets(checkedOutlets, this.props.data.inviteForm))
  }
}

InviteForm.propTypes = {
  onSubmit: React.PropTypes.func,
  dispatch: React.PropTypes.func
}

const mapForm = {
  form: 'invite',
  touchOnBlur: false,
  touchOnChange: true,
  validate
}

const selector = formValueSelector('invite')

function mapStateToProps (state) {
  return {
    data: {
      inviteForm: {
        outlets: selector(state, 'outlets')
      },
      employee: {
        list: state.employee.list
      }
    }
  }
}

export default connect(mapStateToProps)(reduxForm(mapForm)(InviteForm))



// WEBPACK FOOTER //
// ./app/pages/Employees/List/InviteForm/InviteForm.js